'use client';
import style from './style.module.css';

export default function EmptyState() {
  return <div className={style.tagSearchEmpty}></div>;
}
